const flex = {
    row: {
        display: 'flex !important',
        flexDirection: 'row !important',
    },
    column: {
        display: 'flex  !important',
        flexDirection: 'column  !important',
    },
    inline: {
        display: 'inline-flex',
    },
};

export default flex;
